// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs-root-5bx"};